package com.schoolconnect.app.feature.academicyears

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.IntRect
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppDialogColors
import com.schoolconnect.app.designsystem.AppDialogDateField
import com.schoolconnect.app.designsystem.AppDialogDivider
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFieldHeight
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogFormGrid
import com.schoolconnect.app.designsystem.AppDialogInputSize
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.AppDialogSelectField
import com.schoolconnect.app.feature.common.ApiSchoolDropdown
import androidx.compose.ui.window.Popup
import androidx.compose.ui.window.PopupPositionProvider
import androidx.compose.ui.window.PopupProperties
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.chevron_up
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.filter
import ischoolconnect.sharedui.generated.resources.search
import org.jetbrains.compose.resources.painterResource

private val AcademicYearsFilterOverlay = Color(0x730F172A)
private val AcademicYearsFilterSurface = Color.White
private val AcademicYearsFilterFieldBg = Color.White
private val AcademicYearsFilterInputBorder = Color(0xFFE5E7EB)
private val AcademicYearsFilterInputBorderFocused = AcademicYearsPrimary
private val AcademicYearsFilterSelectedBg = Color(0xFFEAF2FF)
private val AcademicYearsFilterError = Color(0xFFC62828)
private val AcademicYearsFilterPopupBorder = AcademicYearsBorder

private val AcademicYearsFilterDialogShape = RoundedCornerShape(12.dp)
private val AcademicYearsFilterFieldShape = RoundedCornerShape(8.dp)
private val AcademicYearsFilterPopupShape = RoundedCornerShape(12.dp)
private val AcademicYearsFilterDialogColors = com.schoolconnect.app.designsystem.AppDialogDefaultColors


@Composable
internal fun AcademicYearsFilterModal(
    open: Boolean,
    initialFilters: AcademicYearFilterCriteria,
    schoolOptions: List<String>,
    startYearOptions: List<String>,
    endYearOptions: List<String>,
    onClose: () -> Unit,
    onApply: (AcademicYearFilterCriteria) -> Unit
) {
    if (!open) return

    var school by remember { mutableStateOf(initialFilters.school) }
    var status by remember { mutableStateOf(initialFilters.status) }
    var startYear by remember { mutableStateOf(initialFilters.startYear) }
    var endYear by remember { mutableStateOf(initialFilters.endYear) }
    var createdFrom by remember { mutableStateOf(initialFilters.createdFrom) }
    var createdTo by remember { mutableStateOf(initialFilters.createdTo) }
    var activeStatus by remember { mutableStateOf(initialFilters.activeStatus) }
    var schoolQuery by remember { mutableStateOf(initialFilters.school) }
    var schoolExpanded by remember { mutableStateOf(false) }
    var statusExpanded by remember { mutableStateOf(false) }
    var startYearExpanded by remember { mutableStateOf(false) }
    var endYearExpanded by remember { mutableStateOf(false) }
    var activeStatusExpanded by remember { mutableStateOf(false) }

    LaunchedEffect(initialFilters) {
        school = initialFilters.school
        status = initialFilters.status
        startYear = initialFilters.startYear
        endYear = initialFilters.endYear
        createdFrom = initialFilters.createdFrom
        createdTo = initialFilters.createdTo
        activeStatus = initialFilters.activeStatus
        schoolQuery = initialFilters.school
        schoolExpanded = false
        statusExpanded = false
        startYearExpanded = false
        endYearExpanded = false
        activeStatusExpanded = false
    }

    val validation = remember(school, status, startYear, endYear, createdFrom, createdTo) {
        academicYearsFilterValidation(
            startYear = startYear,
            endYear = endYear,
            createdFrom = createdFrom,
            createdTo = createdTo
        )
    }
    val effectiveSchoolOptions = schoolOptions.ifEmpty { AcademicYearDefaultSchoolOptions }

    AppDialogScaffold(
        onDismiss = onClose,
        size = AppDialogSize.Standard,
        colors = AcademicYearsFilterDialogColors,
        maxDialogHeight = 720.dp
    ) {
        AppDialogFormGrid(
            modifier = Modifier.fillMaxWidth(),
            compactBreakpoint = 560.dp
        ) { compact ->
            val scrollState = rememberScrollState()

            Column(modifier = Modifier.fillMaxWidth()) {
                AcademicYearsFilterHeader(onClose = onClose)
                AppDialogDivider(colors = AcademicYearsFilterDialogColors)

                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f, fill = false)
                        .verticalScroll(scrollState)
                        .padding(
                            start = if (compact) 20.dp else 28.dp,
                            top = if (compact) 22.dp else 24.dp,
                            end = if (compact) 20.dp else 28.dp,
                            bottom = if (compact) 22.dp else 28.dp
                        ),
                    verticalArrangement = Arrangement.spacedBy(if (compact) 22.dp else 24.dp)
                ) {
                    val schoolField: @Composable (Modifier) -> Unit = { fieldModifier ->
                        AcademicYearsFilterFieldSection(
                            modifier = fieldModifier,
                            label = "School",
                            compact = compact
                        ) {
                            AcademicYearsFilterSchoolSelect(
                                value = school,
                                query = schoolQuery,
                                options = effectiveSchoolOptions,
                                compact = compact,
                                onQueryChange = { schoolQuery = it },
                                onValueChange = {
                                    school = it
                                    schoolQuery = it
                                },
                                onDismiss = { schoolQuery = school }
                            )
                        }
                    }

                    val lifecycleField: @Composable (Modifier) -> Unit = { fieldModifier ->
                        AcademicYearsFilterFieldSection(
                            modifier = fieldModifier,
                            label = "Lifecycle",
                            compact = compact
                        ) {
                            AcademicYearsFilterEnumSelect(
                                value = status,
                                placeholder = "Select lifecycle",
                                options = AcademicYearsFilter.entries,
                                compact = compact,
                                expanded = statusExpanded,
                                onToggleExpanded = { statusExpanded = !statusExpanded },
                                onDismissExpanded = { statusExpanded = false },
                                onSelect = { status = it }
                            )
                        }
                    }

                    val startYearField: @Composable (Modifier) -> Unit = { fieldModifier ->
                        AcademicYearsFilterFieldSection(
                            modifier = fieldModifier,
                            label = "Start Year",
                            compact = compact
                        ) {
                            AcademicYearsFilterSelectField(
                                value = startYear,
                                placeholder = "Select start year",
                                options = startYearOptions,
                                compact = compact,
                                expanded = startYearExpanded,
                                onToggleExpanded = { startYearExpanded = !startYearExpanded },
                                onDismissExpanded = { startYearExpanded = false },
                                onSelect = { startYear = it }
                            )
                        }
                    }

                    val endYearField: @Composable (Modifier) -> Unit = { fieldModifier ->
                        AcademicYearsFilterFieldSection(
                            modifier = fieldModifier,
                            label = "End Year",
                            compact = compact
                        ) {
                            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                                AcademicYearsFilterSelectField(
                                    value = endYear,
                                    placeholder = "Select end year",
                                    options = endYearOptions,
                                    compact = compact,
                                    expanded = endYearExpanded,
                                    onToggleExpanded = { endYearExpanded = !endYearExpanded },
                                    onDismissExpanded = { endYearExpanded = false },
                                    onSelect = { endYear = it }
                                )
                                if (validation.startYearError.isNotBlank()) {
                                    Text(
                                        text = validation.startYearError,
                                        color = AcademicYearsFilterError,
                                        fontSize = 12.sp,
                                        fontWeight = FontWeight.Medium
                                    )
                                }
                            }
                        }
                    }

                    if (compact) {
                        schoolField(Modifier.fillMaxWidth())
                        lifecycleField(Modifier.fillMaxWidth())
                        startYearField(Modifier.fillMaxWidth())
                        endYearField(Modifier.fillMaxWidth())
                    } else {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.spacedBy(24.dp),
                            verticalAlignment = Alignment.Top
                        ) {
                            schoolField(Modifier.weight(1f))
                            lifecycleField(Modifier.weight(1f))
                        }
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.spacedBy(24.dp),
                            verticalAlignment = Alignment.Top
                        ) {
                            startYearField(Modifier.weight(1f))
                            endYearField(Modifier.weight(1f))
                        }
                    }

                    if (compact) {
                        Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                            AcademicYearsFilterDateField(
                                label = "Created from",
                                value = createdFrom,
                                placeholder = "DD MMM YYYY",
                                compact = compact,
                                onValueChange = { createdFrom = it },
                                error = validation.createdRangeError.takeIf { it.isNotBlank() }
                            )
                            AcademicYearsFilterDateField(
                                label = "Created to",
                                value = createdTo,
                                placeholder = "DD MMM YYYY",
                                compact = compact,
                                onValueChange = { createdTo = it },
                                error = validation.createdRangeError.takeIf { it.isNotBlank() }
                            )
                        }
                    } else {
                        Row(horizontalArrangement = Arrangement.spacedBy(24.dp)) {
                            AcademicYearsFilterDateField(
                                label = "Created from",
                                value = createdFrom,
                                placeholder = "DD MMM YYYY",
                                compact = compact,
                                onValueChange = { createdFrom = it },
                                error = validation.createdRangeError.takeIf { it.isNotBlank() },
                                modifier = Modifier.weight(1f)
                            )
                            AcademicYearsFilterDateField(
                                label = "Created to",
                                value = createdTo,
                                placeholder = "DD MMM YYYY",
                                compact = compact,
                                onValueChange = { createdTo = it },
                                error = validation.createdRangeError.takeIf { it.isNotBlank() },
                                modifier = Modifier.weight(1f)
                            )
                        }
                    }

                    Box(modifier = Modifier.fillMaxWidth(if (compact) 1f else 0.5f)) {
                        AcademicYearsFilterFieldSection(
                            label = "Status",
                            compact = compact
                        ) {
                            AcademicYearsFilterSelectField(
                                value = activeStatus.displayLabel(),
                                placeholder = "All",
                                options = listOf("All", "Active", "Inactive"),
                                compact = compact,
                                expanded = activeStatusExpanded,
                                onToggleExpanded = { activeStatusExpanded = !activeStatusExpanded },
                                onDismissExpanded = { activeStatusExpanded = false },
                                onSelect = { activeStatus = it.toAcademicYearActiveStatusFilter() }
                            )
                        }
                    }
                }

                AcademicYearsFilterFooter(
                    onCancel = onClose,
                    onReset = {
                        school = ""
                        status = AcademicYearsFilter.ALL
                        startYear = ""
                        endYear = ""
                        createdFrom = ""
                        createdTo = ""
                        activeStatus = AcademicYearActiveStatusFilter.ALL
                        schoolQuery = ""
                        schoolExpanded = false
                        statusExpanded = false
                        startYearExpanded = false
                        endYearExpanded = false
                        activeStatusExpanded = false
                    },
                    onApply = {
                        if (validation.isValid) {
                            onApply(
                                AcademicYearFilterCriteria(
                                    searchQuery = initialFilters.searchQuery,
                                    school = school.trim(),
                                    status = status,
                                    startYear = startYear.trim(),
                                    endYear = endYear.trim(),
                                    createdFrom = createdFrom.trim(),
                                    createdTo = createdTo.trim(),
                                    activeStatus = activeStatus
                                )
                            )
                        }
                    },
                    compact = compact,
                    enabled = validation.isValid
                )
            }
        }
    }
}

@Composable
private fun AcademicYearsFilterHeader(
    onClose: () -> Unit
) {
    AppDialogHeader(
        title = "Filter Academic Years",
        subtitle = "Narrow down academic year records",
        icon = Res.drawable.filter,
        closeContentDescription = "Close filter academic years modal",
        onClose = onClose,
        colors = AcademicYearsFilterDialogColors
    )
}

@Composable
private fun AcademicYearsFilterFieldSection(
    modifier: Modifier = Modifier,
    label: String,
    compact: Boolean,
    content: @Composable () -> Unit
) {
    AppDialogFieldColumn(
        label = label,
        modifier = modifier,
        colors = AcademicYearsFilterDialogColors,
        contentSpacing = 6.dp,
        field = content
    )
}

@Composable
private fun AcademicYearsFilterDateField(
    label: String,
    value: String,
    placeholder: String,
    onValueChange: (String) -> Unit,
    compact: Boolean,
    error: String? = null,
    modifier: Modifier = Modifier
) {
    AppDialogFieldColumn(
        label = label,
        modifier = modifier,
        error = error.orEmpty(),
        colors = AcademicYearsFilterDialogColors,
        contentSpacing = 6.dp
    ) {
        AppDialogDateField(
            value = value,
            placeholder = placeholder,
            onValueChange = onValueChange,
            fieldHeight = AppDialogFieldHeight,
            fontSize = AppDialogInputSize,
            colors = AcademicYearsFilterDialogColors,
            modifier = Modifier.fillMaxWidth()
        )
    }
}

@Composable
private fun AcademicYearsFilterSelectField(
    value: String,
    placeholder: String,
    options: List<String>,
    compact: Boolean,
    expanded: Boolean,
    onToggleExpanded: () -> Unit,
    onDismissExpanded: () -> Unit,
    onSelect: (String) -> Unit
) {
    AppDialogSelectField(
        value = value,
        placeholder = placeholder,
        expanded = expanded,
        options = options,
        onToggleExpanded = onToggleExpanded,
        onDismissExpanded = onDismissExpanded,
        onSelected = onSelect,
        colors = AcademicYearsFilterDialogColors,
        fontSize = AppDialogInputSize
    )
}

@Composable
private fun AcademicYearsFilterEnumSelect(
    value: AcademicYearsFilter,
    placeholder: String,
    options: List<AcademicYearsFilter>,
    compact: Boolean,
    expanded: Boolean,
    onToggleExpanded: () -> Unit,
    onDismissExpanded: () -> Unit,
    onSelect: (AcademicYearsFilter) -> Unit
) {
    AcademicYearsFilterSelectField(
        value = if (value == AcademicYearsFilter.ALL) "" else value.label(),
        placeholder = placeholder,
        options = options.map { if (it == AcademicYearsFilter.ALL) "All" else it.label() },
        compact = compact,
        expanded = expanded,
        onToggleExpanded = onToggleExpanded,
        onDismissExpanded = onDismissExpanded,
        onSelect = { selected ->
            onSelect(
                options.firstOrNull { option ->
                    if (option == AcademicYearsFilter.ALL) {
                        selected == "All"
                    } else {
                        option.label() == selected
                    }
                } ?: AcademicYearsFilter.ALL
            )
        }
    )
}

private fun AcademicYearsFilter.label(): String = lifecycleLabel()

@Composable
private fun AcademicYearsFilterSchoolSelect(
    value: String,
    query: String,
    options: List<String>,
    onQueryChange: (String) -> Unit,
    onValueChange: (String) -> Unit,
    compact: Boolean,
    onDismiss: () -> Unit
) {
    ApiSchoolDropdown(
        selectedLabel = value,
        onSelected = { option ->
            onValueChange(option.name)
            onDismiss()
        }
    )
    return

    var expanded by remember { mutableStateOf(false) }
    var anchorSize by remember { mutableStateOf(IntSize.Zero) }
    val filteredOptions = remember(query, options) {
        val trimmed = query.trim()
        if (trimmed.isBlank()) options else options.filter { it.contains(trimmed, ignoreCase = true) }
    }
    val popupWidth = with(LocalDensity.current) { anchorSize.width.toDp() }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .onGloballyPositioned { anchorSize = it.size }
    ) {
        Surface(
            modifier = Modifier
                .fillMaxWidth()
                .height(58.dp)
                .clickable(
                    interactionSource = remember { MutableInteractionSource() },
                    indication = null
                ) { expanded = !expanded },
            shape = AcademicYearsFilterFieldShape,
            color = AcademicYearsFilterFieldBg,
            border = androidx.compose.foundation.BorderStroke(
                1.dp,
                if (expanded) AcademicYearsFilterInputBorderFocused else AcademicYearsFilterInputBorder
            )
        ) {
            Row(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(horizontal = if (compact) 18.dp else 24.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = value.ifBlank { "Search and select school" },
                    color = if (value.isBlank()) AcademicYearsMuted else AcademicYearsNavy,
                    fontSize = 16.sp,
                    fontWeight = FontWeight.Medium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                    modifier = Modifier.weight(1f)
                )
                Icon(
                    painter = painterResource(if (expanded) Res.drawable.chevron_up else Res.drawable.chevron_down),
                    contentDescription = null,
                    tint = AcademicYearsNavy,
                    modifier = Modifier.size(if (compact) 20.dp else 28.dp)
                )
            }
        }

        if (expanded) {
            Popup(
                popupPositionProvider = anchoredPopupPositionProvider(),
                properties = PopupProperties(
                    focusable = true,
                    dismissOnBackPress = true,
                    dismissOnClickOutside = true
                ),
                onDismissRequest = {
                    expanded = false
                    onDismiss()
                }
            ) {
                Surface(
                    modifier = Modifier.width(popupWidth),
                    shape = AcademicYearsFilterPopupShape,
                    color = AcademicYearsFilterSurface,
                    border = androidx.compose.foundation.BorderStroke(1.dp, AcademicYearsFilterPopupBorder),
                    shadowElevation = 16.dp
                ) {
                    Column {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(58.dp)
                                .padding(horizontal = 18.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Icon(
                                painter = painterResource(Res.drawable.search),
                                contentDescription = null,
                                tint = AcademicYearsMuted,
                                modifier = Modifier.size(20.dp)
                            )
                            Spacer(modifier = Modifier.size(10.dp))
                            BasicTextField(
                                value = query,
                                onValueChange = onQueryChange,
                                singleLine = true,
                                textStyle = TextStyle(
                                    fontSize = 16.sp,
                                    fontWeight = FontWeight.Medium,
                                    color = AcademicYearsNavy
                                ),
                                cursorBrush = SolidColor(com.schoolconnect.app.designsystem.AppPrimary),
                                modifier = Modifier.fillMaxWidth()
                            ) { innerTextField ->
                                Box(
                                    modifier = Modifier.fillMaxWidth(),
                                    contentAlignment = Alignment.CenterStart
                                ) {
                                    if (query.isBlank()) {
                                        Text(
                                            text = "Search school...",
                                            color = AcademicYearsMuted,
                                            fontSize = 16.sp,
                                            fontWeight = FontWeight.Medium,
                                            maxLines = 1,
                                            overflow = TextOverflow.Ellipsis
                                        )
                                    }
                                    innerTextField()
                                }
                            }
                        }

                        HorizontalDivider(color = AcademicYearsBorder)

                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .heightIn(max = 280.dp)
                                .verticalScroll(rememberScrollState())
                                .padding(vertical = 10.dp)
                        ) {
                            if (filteredOptions.isEmpty()) {
                                Text(
                                    text = "No schools found",
                                    color = AcademicYearsMuted,
                                    fontSize = 14.sp,
                                    fontWeight = FontWeight.Medium,
                                    modifier = Modifier.padding(horizontal = 18.dp, vertical = 14.dp)
                                )
                            } else {
                                filteredOptions.forEach { school ->
                                    val selected = school == value
                                    Box(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .height(40.dp)
                                            .background(if (selected) AcademicYearsFilterSelectedBg else Color.Transparent)
                                            .clickable {
                                                onValueChange(school)
                                                expanded = false
                                                onDismiss()
                                            }
                                            .padding(horizontal = 18.dp),
                                        contentAlignment = Alignment.CenterStart
                                    ) {
                                        Text(
                                            text = school,
                                            color = AcademicYearsNavy,
                                            fontSize = 15.sp,
                                            fontWeight = FontWeight.Medium,
                                            maxLines = 1,
                                            overflow = TextOverflow.Ellipsis
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun AcademicYearsFilterFooter(
    onCancel: () -> Unit,
    onReset: () -> Unit,
    onApply: () -> Unit,
    compact: Boolean,
    enabled: Boolean
) {
    AppDialogFooter(
        actions = listOf(
            AppDialogFooterAction(label = "Cancel", onClick = onCancel),
            AppDialogFooterAction(label = "Reset", onClick = onReset),
            AppDialogFooterAction(
                label = "Apply",
                onClick = onApply,
                style = AppDialogActionStyle.Primary,
                enabled = enabled
            )
        ),
        colors = AcademicYearsFilterDialogColors,
        contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = if (compact) 20.dp else 28.dp)
    )
}

private data class AcademicYearsFilterValidation(
    val startYearError: String = "",
    val createdRangeError: String = ""
) {
    val isValid: Boolean
        get() = startYearError.isBlank() && createdRangeError.isBlank()
}

private fun academicYearsFilterValidation(
    startYear: String,
    endYear: String,
    createdFrom: String,
    createdTo: String
): AcademicYearsFilterValidation {
    val yearError = if (startYear.isNotBlank() && endYear.isNotBlank()) {
        val startComparable = startYear.toIntOrNull()
        val endComparable = endYear.toIntOrNull()
        if (startComparable != null && endComparable != null && startComparable > endComparable) {
            "Start year must be less than or equal to end year."
        } else {
            ""
        }
    } else {
        ""
    }

    val createdError = if (createdFrom.isNotBlank() && createdTo.isNotBlank()) {
        val fromComparable = academicYearDateComparable(createdFrom)
        val toComparable = academicYearDateComparable(createdTo)
        if (fromComparable != null && toComparable != null && fromComparable > toComparable) {
            "From date must be before To date."
        } else {
            ""
        }
    } else {
        ""
    }

    return AcademicYearsFilterValidation(
        startYearError = yearError,
        createdRangeError = createdError
    )
}

private fun anchoredPopupPositionProvider(): PopupPositionProvider {
    return object : PopupPositionProvider {
        override fun calculatePosition(
            anchorBounds: IntRect,
            windowSize: IntSize,
            layoutDirection: androidx.compose.ui.unit.LayoutDirection,
            popupContentSize: IntSize
        ): IntOffset {
            val x = anchorBounds.left.coerceIn(0, (windowSize.width - popupContentSize.width).coerceAtLeast(0))
            val belowY = anchorBounds.bottom + 10
            val aboveY = anchorBounds.top - popupContentSize.height - 10
            val y = if (belowY + popupContentSize.height <= windowSize.height) {
                belowY
            } else {
                aboveY.coerceAtLeast(0)
            }
            return IntOffset(x, y)
        }
    }
}
